import { Box } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormLabel from '@mui/material/FormLabel';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '../../../components/button';
import { H2, H4 } from '../../../components/typography';
import { useAPI } from '../../../hooks/useAPI';
import { COLORS } from '../../../theme';

const TenantBackgroundControl = () => {
  const queryParameters = new URLSearchParams(window.location.search);
  const { backgroundCheck, isLoading } = useAPI();
  const [formValues, setFormValues] = useState({});
  const [hasSubmitted, setHasSubmitted] = useState(false);
  const applicationId = queryParameters.get('application-id');
  const tenantNumber = queryParameters.get('tenant-number');
  const { t } = useTranslation();

  const onSubmit = async () => {
    await backgroundCheck({ ...formValues, applicationId });
    setHasSubmitted(true);
  };

  const handleRadioChange = (event) => {
    const { name, value } = event.target;
    setFormValues({
      ...formValues,
      [name]: value === 'True'
    });
  };

  if (hasSubmitted) {
    return (
      <Box>
        <H2 fontWeight="bold">{t('background_check_sent')}</H2>
      </Box>
    );
  }

  if (isLoading) {
    return (
      <Box>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box>
      <H2 fontWeight="bold">{t('bg_check_text_0')}</H2>
      <H4 fontWeight="bold">{`Personnummer: ${tenantNumber}`}</H4>
      <FormControl sx={{ marginTop: 3 }}>
        <FormLabel id="prosecuted">{t('bg_check_text_1')}</FormLabel>
        <RadioGroup
          row
          aria-labelledby="prosecuted"
          name="prosecuted"
          onChange={handleRadioChange}
        >
          <FormControlLabel value="True" control={<Radio />} label="Ja" />
          <FormControlLabel value="False" control={<Radio />} label="Nej" />
        </RadioGroup>
        <FormLabel id="litigation">{t('bg_check_text_2')}</FormLabel>
        <RadioGroup
          row
          aria-labelledby="litigation"
          name="litigation"
          onChange={handleRadioChange}
        >
          <FormControlLabel value="True" control={<Radio />} label="Ja" />
          <FormControlLabel value="False" control={<Radio />} label="Nej" />
        </RadioGroup>
        <FormLabel id="paymentRemarks">{t('bg_check_text_3')}</FormLabel>
        <RadioGroup
          row
          aria-labelledby="paymentRemarks"
          name="paymentRemarks"
          onChange={handleRadioChange}
        >
          <FormControlLabel value="True" control={<Radio />} label="Ja" />
          <FormControlLabel value="False" control={<Radio />} label="Nej" />
        </RadioGroup>
        <FormLabel id="kronofogden">{t('bg_check_text_4')}</FormLabel>
        <RadioGroup
          row
          aria-labelledby="kronofogden"
          name="kronofogden"
          onChange={handleRadioChange}
        >
          <FormControlLabel value="True" control={<Radio />} label="Ja" />
          <FormControlLabel value="False" control={<Radio />} label="Nej" />
        </RadioGroup>
        <FormLabel id="inkomstOk">{t('bg_check_text_5')}</FormLabel>
        <RadioGroup
          row
          aria-labelledby="inkomstOk"
          name="inkomstOk"
          onChange={handleRadioChange}
        >
          <FormControlLabel value="True" control={<Radio />} label="Ja" />
          <FormControlLabel value="False" control={<Radio />} label="Nej" />
        </RadioGroup>
        <Button
          type="submit"
          backgroundColor={COLORS.primary}
          textcolor={COLORS.white}
          bordercolor={COLORS.primary}
          onClick={onSubmit}
          disabled={(Object.values(formValues).length < 5) | isLoading}
        >
          {t('submit')}
        </Button>
      </FormControl>
    </Box>
  );
};

export default TenantBackgroundControl;
